import { property } from "lit/decorators.js";

import { FormElement } from "../form-element.ts";

export abstract class ToggleBase extends FormElement {
  @property({ type: Boolean, reflect: true }) checked = false;
  @property({ type: Boolean, reflect: true }) disabled = false;

  protected updateStateFromEvent(el: HTMLInputElement) {
    this.checked = el.checked;
    this.value = el.checked ? el.value : "";
  }
}
